import React, { useState, useEffect } from 'react'
import styled from 'styled-components'

import { useScrollTrigger } from '../../data/hooks/interface/scroll-trigger'

type PopUpProps = {
    isOpen: boolean
    onBottomReached?: () => void
    dependencies?: Array<any>
    bottomStopCondition?: () => boolean
    reset?: () => void
    className?: string
}

const PopUp: React.FunctionComponent<PopUpProps> = ({ className, onBottomReached, bottomStopCondition, reset, dependencies, isOpen, children }) => {
  const [scrollParent, setScrollParent] = useState<HTMLDivElement | null>(null)

  const [scrollable, setScrollable] = useScrollTrigger({
    onBottomReached,
    bottomStopCondition,
    dependencies,
    scrollParent,
  })

  useEffect(() => {
    if (!isOpen) {
      return
    }

    reset && reset()
  }, [...(dependencies || []), isOpen])


  return (
    <Container isOpen={isOpen} ref={r => setScrollParent(r)} className={className}>
      <Scrollable ref={r => setScrollable(r)}>
        { children }
      </Scrollable>
    </Container>
  )
}

const Container = styled.div<{ isOpen: boolean}>`
  position: absolute;
  top: 100%;
  left: 0;

  padding-bottom: 10px;
  
  min-width: 100%;

  display: ${p => p.isOpen ? 'grid' : 'none'};
  
  border-radius: 0 0 10px 10px;
  box-shadow: 0px 10px 32px 0px #0000000D;

  background: ${p => p.theme.colors.bg};

  overflow-y: auto;
`

const Scrollable = styled.div`
  width: 100%;
  min-height: 100%;

  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  justify-items: center;

  z-index: 10;
`

export default PopUp